import { COMPACT_AUTH_STEPS } from "./compactAuth.types";

export interface CompactAuthShellMeta {
    stepLabel: string;
    title: string;
}

export interface CompactAuthShellMetaKeys {
    /** i18n key for the step counter label, e.g. "Step {{current}} of {{total}}: Verify number" */
    stepLabelKey: string;
    /** i18n key for the title shown on the phone-number step */
    phoneTitleKey: string;
    /** i18n key for the title shown on the OTP step */
    otpTitleKey: string;
}

/** Shared header copy (step label + title) for the login step, reused by both the compact posting and bidding shells. */
export function getCompactAuthShellMeta(
    loginStep: COMPACT_AUTH_STEPS,
    totalSteps: number,
    translate: (key: string, options?: Record<string, number>) => string,
    keys: CompactAuthShellMetaKeys,
    loginStepIndex = 2
): CompactAuthShellMeta {
    const stepLabel = translate(keys.stepLabelKey, { current: loginStepIndex, total: totalSteps });

    switch (loginStep) {
        case COMPACT_AUTH_STEPS.OTP:
            return { stepLabel, title: translate(keys.otpTitleKey) };
        case COMPACT_AUTH_STEPS.PHONE:
        default:
            return { stepLabel, title: translate(keys.phoneTitleKey) };
    }
}
